export class IExportTemplate {
  deviceAttributes: DeviceAttribute[];
}

export class DeviceAttribute {
  name: string;
  caption: string;
  importXpathRoot: string;
  importXpathLoop: string;
  sections: Section[];
  fields: Field[];
}

export class Section {
  name: string;
  caption: string;
  importXpathRoot: string;
  importXpathLoop: string;
  sections: Section[];
  fields: Field[];
}

class Field {
  name: string;
  caption: string;
  populatesField: string;
  importXpath: string;
  isSelected: boolean;
}
